import { Component, Input, ViewChild } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { LoginModel } from './login.component.models';
import { Router } from '@angular/router';
import { AppContext } from '../app.context';
import { MatFormField, MatInput, MatInputModule } from '@angular/material/input';
import { MatFormFieldControl } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { env } from '../../env/env';
import { SKIP_ERROR_INTERCEPTOR } from '../_infrastructure/errors-interceptor';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [
    MatInput,
    MatFormField,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule
  ]
})

export class LoginComponent {
  constructor(private httpClient: HttpClient, private appContext: AppContext) {

  }

  ngOnInit() {
  }

  public loginError: any;
  public model: LoginModel = new LoginModel();

  public login(): void {
    if (this.model.isIncomplete()) {
      return this.error('Podaj login i hasło');
    }
    this.loginError = null;
    this.httpClient.post(env.apiUrl + '/login', this.model, {
      responseType: 'text',
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    }).subscribe({
      next: s => {
        this.appContext.logIn(s as string);
        window.location.assign('/clients');
      },
      error: e => {
        const message = typeof e.error === 'string' && e.error.length
          ? e.error
          : 'Wystąpił błąd. Spróbuj ponownie.';
        this.error(message);
      }
    });
  }

  private error(text: string) {
    this.loginError = text;
  }
}
